import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface TableRightChevronsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const TableRightChevronsIcon = ({ className, ...props }: TableRightChevronsIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 7L12 12L7 17M13 7L18 12L13 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default TableRightChevronsIcon;
